import React from "react";
import { useLocation } from "react-router-dom";

import {
  Context,
  clearSuccessMessage,
  fetchMyAnswers,
  fetchLesson,
  registerAnswers,
  postEvaluateLesson,
  fetchTeachingMaterial,
  fetchOnePagePortfolioAssessment,
  registerOnePagePortfolioAssessmentAnswers,
  REGISTER_ANSWERS_SUCCESS,
  fetchGearboxId,
  fetchOpenedClasses,
} from "../../../studentStore";
import { REGISTER_ANSWERS_SUCCESS_MSG } from "../../../studentStore/messages";
import { parseQueryParams } from "../../../libs/Util";
import TextBookForImage from "../../../templates/student/TextBookForImage";
import {
  ILessonRetrospectiveScore,
  INewAnswer,
  OnePagePortfolioAssessmentAnswer,
} from "../../../state";
import useWaitApiCall from "../../../hooks/useWaitApiCall";

export default () => {
  const { state, dispatch } = React.useContext(Context);
  const [calling, peep] = useWaitApiCall(state);
  const lesson_id = Number(parseQueryParams()["lesson"]);
  const location = useLocation();
  const teachingMaterialId = Number(location.pathname.split("/")[2]);

  React.useEffect(() => {
    dispatch(fetchLesson(lesson_id));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lesson_id]);

  React.useEffect(() => {
    dispatch(fetchTeachingMaterial(teachingMaterialId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [teachingMaterialId]);

  const getOpenClasses = (issueId: number) => {
    dispatch(fetchOpenedClasses(issueId));
  };

  const getMyAnswers = (issueId: number) => {
    dispatch(fetchMyAnswers(issueId));
  };

  const sendAnswers = (issueId: number, answers: INewAnswer[]) => {
    dispatch(peep(registerAnswers(issueId, answers)));
  };

  const sendEvaluateLesson = (
    student_lesson_retrospective: ILessonRetrospectiveScore,
  ) => {
    dispatch(postEvaluateLesson(student_lesson_retrospective, lesson_id));
    dispatch(fetchGearboxId(lesson_id));
  };

  const handleClearSuccessMessage = () => {
    clearSuccessMessage();
  };

  const fetchOnePagePortfolioAssessmentFunc = (id: number) => {
    dispatch(fetchOnePagePortfolioAssessment(id));
  };

  const registerOnePagePortfolioAssessmentAnswersFunc = (
    id: number,
    answers: OnePagePortfolioAssessmentAnswer[],
  ) => {
    dispatch(peep(registerOnePagePortfolioAssessmentAnswers(id, answers)));
  };

  return (
    <div className="d-flex h-100">
      {state.lesson && state.lesson.id === lesson_id && (
        <TextBookForImage
          lesson={state.lesson}
          myAnswers={state.my_answers}
          nextLessonId={state.next_lesson_id}
          prevLessonId={state.prev_lesson_id}
          isG4sEnabled={!!state.student?.g4s_enabled || state.g4s_basic_enabled}
          isSuccessSendAnswers={
            state.success_message === REGISTER_ANSWERS_SUCCESS_MSG
          }
          isRegisterAnswersSuccess={
            state.lastAction === REGISTER_ANSWERS_SUCCESS
          }
          calling={calling}
          getMyAnswers={getMyAnswers}
          getOpenClasses={getOpenClasses}
          sendAnswers={sendAnswers}
          sendEvaluateLesson={sendEvaluateLesson}
          clearSuccessMessage={handleClearSuccessMessage}
          fetchOnePagePortfolioAssessment={fetchOnePagePortfolioAssessmentFunc}
          registerOnePagePortfolioAssessmentAnswers={
            registerOnePagePortfolioAssessmentAnswersFunc
          }
        />
      )}
    </div>
  );
};
